import { once } from 'dygc'

// H5 SDK接入全局只需运行一次
const loadScript = once(() => {
  var doc = document,
    h = doc.getElementsByTagName('head')[0],
    s = doc.createElement('script')
  s.async = true
  s.src = 'https://qzs.gdtimg.com/union/res/union_sdk/page/h5_sdk/i.js'
  h && h.insertBefore(s, h.firstChild)
})

export function initAnswerEndAdsense() {
  if(process.env.NODE_ENV==="development") return
  window.TencentGDT = window.TencentGDT || []

  // 广告初始化
  window.TencentGDT.push({
    app_id: '1201074883', // {String} - appid - 必填
    placement_id: '1044036305782282', // {String} - 广告位id - 必填
    type: 'native', // {String} - 原生广告类型 - 必填
    count: 1, // {Number} - 拉取广告的数量，默认是3，最高支持10 - 选填
    onComplete: function (res) {
      console.log(res)
      if (res && res.constructor === Array) {
        // 原生模板广告位调用 window.TencentGDT.NATIVE.renderAd(res[0], 'containerId') 进行模板广告的渲染
        // res[0] 代表取广告数组第一个数据
        // containerId：广告容器ID
        window.TencentGDT.NATIVE.renderAd(res[0], 'TencentGDTContainer')
      } else {
        // 加载广告API，如广告回调无广告，可使用loadAd再次拉取广告
        // 注意：拉取广告频率每分钟不要超过20次，否则会被广告接口过滤，影响广告位填充率
        setTimeout(function () {
          window.TencentGDT.NATIVE.loadAd('1044036305782282')
        }, 3000)
      }
    }
  })

  loadScript()
}

export function initBannerAdsense(containerid, config) {
  if(process.env.NODE_ENV==="development") return
  // 腾讯广告全局申明只需运行一次
  window.TencentGDT = window.TencentGDT || []

  // 广告示例声明
  TencentGDT.push({
    app_id: '1201074883',
    placement_id: '7064932482269369', // 广告位id，请从联盟平台广告位获取
    type: 'native', // 广告类型
    display_type: 'banner', // 广告播放类型: banner广告
    carousel: 3000, // 轮播时间，> 3000数字类型，否则轮播会被取消
    containerid: containerid || 'bannerAd', // 广告容器
    onComplete: function (res) {
      if (res.ret == 0) {
        console.log('广告播放成功')
        if (config.success) {
          config.success()
        }
      } else {
        if (config.fail) {
          config.fail()
        }
        console.log('广告播放失败')
      }
    }
  })

  loadScript()
}
